__turbopack_context__.v({
  "blok-big-title": "CartSummary-module__mmfdcG__blok-big-title",
  "blok-subtitle": "CartSummary-module__mmfdcG__blok-subtitle",
  "blok-title": "CartSummary-module__mmfdcG__blok-title",
  "cart__actions": "CartSummary-module__mmfdcG__cart__actions",
  "checkout-button": "CartSummary-module__mmfdcG__checkout-button",
  "grandtotal": "CartSummary-module__mmfdcG__grandtotal",
  "isCheckout": "CartSummary-module__mmfdcG__isCheckout",
  "shipping-text": "CartSummary-module__mmfdcG__shipping-text",
  "subtotals": "CartSummary-module__mmfdcG__subtotals",
  "summary": "CartSummary-module__mmfdcG__summary",
  "summaryTexts": "CartSummary-module__mmfdcG__summaryTexts",
});
